import React from 'react';
import './offers.scss';

import {IsRole_Admin, IsRole_Manager, IsRole_Operator,IsRole_SalesManager} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 
import { createStore } from 'devextreme-aspnet-data';

import DataGrid, {
    Column,
    Export,
    //Popup,
    Form,
    //Button,
    Pager,
    Paging,
    FilterRow,
    HeaderFilter,
    Lookup,
    Editing,
    Selection,
    Summary,
    Format,
    //GroupItem,
    TotalItem,
    Toolbar,
    SearchPanel
  } from 'devextreme-react/data-grid';

  import notify from 'devextreme/ui/notify';
  import { Button } from 'devextreme-react/button';
  import { useState, useEffect } from "react";
  

  import { formatNumber } from 'devextreme/localization';


  import {Popup} from 'devextreme-react/popup';

  
  import  {   
    Item,SimpleItem,ButtonItem, Label,ToolbarItem 
  } from 'devextreme-react/form';




  const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaDettaglio'
  const debug = process.env.ENTITY_DEBUG;

export default function OfferDetailSale(props) {

    var dataGridRef = React.createRef();

    const filterPayload = { 
        idSuper: props.myKey
    };

    const [tipiArticolo, setTipiArticolo] = useState({});
    const [um, setUm] = useState({});
    const [imposte, setImposte] = useState({});

    const { user } = useAuth(); 

    const isAdmin=IsRole_Admin();
    //console.log('IsAdmin: ' + isAdmin);
    
    const isSalesManager=IsRole_SalesManager();
    //console.log('IsSalesManager: ' + isSalesManager);

    useEffect(() => {

        const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
        var newUrl =  newServiceUrl + "/GetAction";

        const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
        var newUrl2 =  newServiceUrl2 + "/GetAction";

        const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
        var newUrl3 =  newServiceUrl3 + "/GetAction";

        const fetchData = async () => {
            try {

                const response = await fetch(newUrl);
                const json = await response.json();
                if (debug === 1)
                    console.log(json);
                setTipiArticolo(json);

                const response2 = await fetch(newUrl2);
                const json2 = await response2.json();
                if (debug === 1)
                    console.log(json2);
                setUm(json2);

                const response3 = await fetch(newUrl3);
                const json3 = await response3.json();
                if (debug === 1)
                    console.log(json3);
                setImposte(json3);

            } catch (error) {
                console.log("error", error);
            }
        };
        fetchData();
    }, []);


    function customizeText(data) {
        return `Righe: ${data.value}`;
    }

    function customizeData(data) {
        return `PV Totale: ${formatNumber(data.value, '###,##0.00')}`;
    }

    function onInitNewRow(e) {
        //e.data.offertaId = props.data.key;
        e.data.offertaId = props.myKey;
    };

    function calculatePVUnitario(rowData) {
        return rowData.paScontato;
    };

    // function onToolbarPreparing(e) {
    //     var item = e.toolbarOptions.items.find(item => item.name === "addRowButton"); 
    //         item.options.icon = "doc";  
    //         item.options.hint= "Nota";  
       
    // };
    
const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
        if (method === "load" ) {           
            var payload = ajaxOptions.data;
            payload.values = JSON.stringify(filterPayload);
            ajaxOptions.data = payload;          
        }  
        ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  function refreshDataGrid() {
    dataGridRef.instance().refresh();
  }

  function showMessage() {
    //notify("The button was clicked");
    dataGridRef.instance().refresh();
    //handleChange();
}

const submitButtonOptions = {
    text: "Conferma",
    type:"success",
    useSubmitBehavior: true
  };
  
  function onRowInserting(e) {
    e.data.createBy = user.name;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  function allowModify() {
    //se  Marketing (1) o RDO (10) o Persa (4) o Non Processata (5) possono modificarla tutti altrimenti se Completata(11) solo il ruolo admin o salesmanager
    if((props.status === 1 || props.status === 10 || props.status === 4 || props.status === 5 ) || ((isAdmin || isSalesManager) &&  (props.status === 11)))
      return true
    else
      return false     
  };

return (
    <div>
        <DataGrid id="grid-container"
            dataSource={remoteDataSource}
            showBorders={true}
            columnAutoWidth={true}
            onInitNewRow={onInitNewRow}
            //onToolbarPreparing = {onToolbarPreparing}
            ref={ref => dataGridRef = ref}
            onRowUpdating={onRowUpdating}
            onRowInserting={onRowInserting}
        >
            <Paging  defaultPageSize={40}/>
            <Pager showPageSizeSelector={true} showInfo={true} />
            <Toolbar>
                <Item location="after">
                    <Button className="offer-toolbar"
                    icon='refresh'
                    hint='Aggiorna'
                    onClick={refreshDataGrid} 
                    />
                </Item>
                
            </Toolbar>
            <HeaderFilter visible={true} />
            <Summary>
            <TotalItem
                column="codice"
                summaryType="count"
                customizeText={customizeText}
            />
             <TotalItem
              column="pvTotale"
              summaryType="sum" 
              customizeText={customizeData}
              />
            </Summary>
            <Selection mode="single" />
            <Editing
            mode="row"
            allowUpdating={allowModify}
            allowAdding={false}
            allowDeleting={allowModify}
            useIcons={true}
            ></Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="offertaId" visible={false}/>
            <Column dataField="hidden" caption="Nasc." width={100}/>
            <Column dataField="tipoRigaId" caption="Tipo" width={80} allowEditing={false}>
                <Lookup dataSource={tipiArticolo} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="codiceAlias" caption="Codice" width={100} allowEditing={false}/>
            <Column dataField="descrizione" caption="Descrizione" width={400}/>
            <Column dataField="impostaId" caption="IVA" width={60}>
                <Lookup dataSource={imposte} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="umid" caption="UM" width={60} >
                <Lookup dataSource={um} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="quantità" caption="Q.tà" allowEditing={false} width={80}/>
            <Column dataField="paScontato"  caption="PA Unit." allowEditing={false} visible={false}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="pvUnitario" caption="PA Unit." allowEditing={false}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="pvPercRicarico" caption="% Ricarico" > 
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="pvRicarico" caption="Ricarico" > 
                <Format type="fixedPoint" precision={2} />
            </Column>
       
            <Column dataField="pvRicaricato" caption="PV Unit." allowEditing={false}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="pvTotale" caption="PV Totale" allowEditing={false} >
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="percCommissione" caption="% Comm." > 
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="updateBy" visible={false}/>
            <Column dataField="createBy" visible={false}/> 

        </DataGrid>
    </div>  
)};